// extracted by mini-css-extract-plugin
module.exports = {"infoText":"PersonRecoveryPage_infoText__vCZ2B"};